export default __webpack_public_path__ + "images/bfa487ef2be76fd1440ca4930d111d49-foster_parent_tips.svg";